import React from 'react';
import {
    BigtopUpdatesRounded,
    SignalDisconnectedRounded,
} from '@mui-symbols-material/w200';

interface HubProps {
    iotHubConnectivityStatus: string;
}

const HUB_ICON_COLOR = '#666666';
const HUB_ICON_SIZE = 44;

export const hubConnectivityFunc = ({ iotHubConnectivityStatus }: HubProps) => {
    if (iotHubConnectivityStatus === "CONNECTED") {
        return "Online";
    }
    if (iotHubConnectivityStatus === "DISCONNECTED") {
        return "Offline";
    }
    return "";
};

export const hubFunc = ({ iotHubConnectivityStatus }: HubProps) => {
    if (iotHubConnectivityStatus === "CONNECTED") {
        return "Iot hub connected";
    }
    if (iotHubConnectivityStatus === "DISCONNECTED") {
        return "Iot hub disconnected";
    }
    return "";
};

export const hubConnectivityIconFunc = ({ iotHubConnectivityStatus }: HubProps) => {
    if (iotHubConnectivityStatus === "CONNECTED") {
        return <BigtopUpdatesRounded sx={{ fontSize: `${HUB_ICON_SIZE}px`, color: HUB_ICON_COLOR }} />;
    }
    if (iotHubConnectivityStatus === "DISCONNECTED") {
        return <SignalDisconnectedRounded sx={{ fontSize: `${HUB_ICON_SIZE}px`, color: HUB_ICON_COLOR }} />;
    }
    return null;
};
